// extracted by mini-css-extract-plugin
export default {"ErrorPage":"df00YLS1","btn":"EVgVzcYt"};